export const SITE_2524_WHATSAPP_URL = 'https://api.cqc.onpromedia.com.br/t/FC401582';

export const resolveSite2524WhatsAppUrl = (site: any, fallbackUrl: string) =>
    Number(site?.id) === 2524 ? SITE_2524_WHATSAPP_URL : fallbackUrl;
